import { render, staticRenderFns } from "./Reservation.vue?vue&type=template&id=cf73137e&scoped=true&"
import script from "./Reservation.vue?vue&type=script&lang=js&"
export * from "./Reservation.vue?vue&type=script&lang=js&"
import style0 from "./Reservation.vue?vue&type=style&index=0&id=cf73137e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf73137e",
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BCard, BTable, BButton, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BCard, BTable, BButton, BContainer})
    

export default component.exports